"use strict";module.exports=require("is-callable");